module.exports = __webpack_public_path__ + "static/img/华为 HUAWEI WATCH D2.a4fb8680.png";